<template>
  <div>
    <!-- 查询筛选区域 -->
    <div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-input
            placeholder="检测员"
            v-model="searchParams.inspectorName"
            clearable>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            placeholder="手机号"
            v-model="searchParams.phone"
            clearable>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="设备ID"
            v-model="searchParams.deviceId"
            clearable>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="searchParams.startTime"
            type="date"
            placeholder="开始时间"
            value-format="YYYY-MM-DD"
            clearable
            style="width: 100%">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="searchParams.endTime"
            type="date"
            placeholder="结束时间"
            value-format="YYYY-MM-DD"
            clearable
            style="width: 100%">
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
      <br/>
      <div>
        <el-button type="success" @click="handleExport">导出Excel</el-button>
        <el-button type="warning" @click="showScheduledDialog = true">定时导出</el-button>
      </div>
    </div>
    <br/>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      v-loading="loading">
      <el-table-column type="index" label="序号" width="60" :index="indexMethod" />
      <el-table-column prop="inspectorName" label="检测员" width="120" />
      <el-table-column prop="phone" label="手机号" width="130" />
      <el-table-column prop="permission" label="权限" width="80">
        <template #default="{ row }">
          {{ row.permission === 0 ? '超管' : row.permission === 1 ? '管理' : row.permission === 2 ? '普通' : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="deviceId" label="设备ID" min-width="200" show-overflow-tooltip />
      <el-table-column prop="deviceName" label="设备名称" min-width="120" />
      <el-table-column prop="totalDetectionCount" label="设备总检测次数" width="130" />
      <el-table-column prop="bindDays" label="绑定至今(天)" width="120" />
      <el-table-column prop="accountCreateTime" label="账号创建时间" width="170" />
      <el-table-column prop="bindTime" label="绑定时间" width="170" />
      <el-table-column prop="bindUpdateTime" label="绑定更新日期" width="170" />
      <el-table-column prop="deviceCreateTime" label="设备创建时间" width="170" />
    </el-table>

    <br/>
    <!-- 分页控制 -->
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.current"
        :page-size="pageParams.pageSize"
        :page-sizes="[20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageParams.total">
      </el-pagination>
    </div>

    <!-- 定时导出弹窗 -->
    <el-dialog
      v-model="showScheduledDialog"
      title="定时导出"
      width="984px"
      :close-on-click-modal="false">
      <div style="margin-bottom: 16px;">
        <el-alert
          title="系统将在每周一早上 8:00 自动导出上一周（周一 ~ 周日）所有设备的检测记录"
          type="info"
          :closable="false"
          show-icon />
      </div>
      <div style="margin-bottom: 16px;">
        <el-button type="primary" @click="handleTriggerScheduledExport" :loading="triggerLoading">
          立即导出一份
        </el-button>
        <span style="color: #909399; font-size: 13px; margin-left: 8px;">
          导出一份上一周的检测周报，与定时任务导出内容一致
        </span>
      </div>
      <el-divider content-position="left">历史导出记录</el-divider>
      <el-table
        :data="scheduledExports"
        border
        stripe
        style="width: 100%"
        v-loading="scheduledLoading"
        empty-text="暂无导出记录">
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="fileName" label="文件名" min-width="200" show-overflow-tooltip />
        <el-table-column label="统计周期" width="170">
          <template #default="{ row }">
            {{ row.weekStart }} ~ {{ row.weekEnd }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceCount" label="设备数" width="70" />
        <el-table-column label="导出类型" width="80">
          <template #default="{ row }">
            <el-tag :type="row.exportType === 'SCHEDULED' ? 'success' : 'warning'" size="small">
              {{ row.exportType === 'SCHEDULED' ? '定时' : '手动' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">
              {{ statusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" width="90">
          <template #default="{ row }">
            {{ formatFileSize(row.fileSize) }}
          </template>
        </el-table-column>
        <el-table-column label="生成时间" width="160">
          <template #default="{ row }">
            {{ row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              @click="handleDownloadScheduled(row.fileName)"
              :disabled="row.status !== 'SUCCESS'">
              下载
            </el-button>
            <el-button
              type="danger"
              link
              @click="handleDeleteExport(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { fetchDetectionManagePage, exportDetectionManage } from '@/api/detectionManage';
import {
  listScheduledExports,
  triggerScheduledExport,
  downloadScheduledExport,
  deleteScheduledExport
} from '@/api/detectionManage';

export default {
  name: 'DetectionManagement',
  data() {
    return {
      searchParams: {
        inspectorName: '',
        phone: '',
        deviceId: '',
        startTime: '',
        endTime: '',
      },
      tableData: [],
      loading: false,
      pageParams: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      showScheduledDialog: false,
      scheduledExports: [],
      scheduledLoading: false,
      triggerLoading: false,
    };
  },
  methods: {
    indexMethod(index) {
      return (this.pageParams.current - 1) * this.pageParams.pageSize + index + 1;
    },
    handleSearch() {
      this.pageParams.current = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchParams = {
        inspectorName: '',
        phone: '',
        deviceId: '',
        startTime: '',
        endTime: '',
      };
      this.pageParams.current = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.pageParams.current = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pageParams.current = val;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      try {
        const requestData = {
          inspectorName: this.searchParams.inspectorName || undefined,
          phone: this.searchParams.phone || undefined,
          deviceId: this.searchParams.deviceId || undefined,
          startTime: this.searchParams.startTime || undefined,
          endTime: this.searchParams.endTime || undefined,
          current: this.pageParams.current,
          pageSize: this.pageParams.pageSize,
        };
        const response = await fetchDetectionManagePage(requestData);
        if (response.data && response.data.records) {
          this.tableData = response.data.records;
          this.pageParams.total = response.data.total;
        } else {
          this.tableData = [];
          this.pageParams.total = 0;
        }
      } catch (error) {
        ElMessage.error('查询失败：' + (error.message || '未知错误'));
      } finally {
        this.loading = false;
      }
    },
    async handleExport() {
      try {
        const requestData = {
          inspectorName: this.searchParams.inspectorName || undefined,
          phone: this.searchParams.phone || undefined,
          deviceId: this.searchParams.deviceId || undefined,
          startTime: this.searchParams.startTime || undefined,
          endTime: this.searchParams.endTime || undefined,
        };
        const response = await exportDetectionManage(requestData);
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const now = new Date();
        const dateStr = now.getFullYear() + '-' +
          String(now.getMonth() + 1).padStart(2, '0') + '-' +
          String(now.getDate()).padStart(2, '0');
        link.download = '检测管理_' + dateStr + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error('导出失败：' + (error.message || '未知错误'));
      }
    },
    async fetchScheduledExports() {
      this.scheduledLoading = true;
      try {
        const response = await listScheduledExports();
        this.scheduledExports = response.data || [];
      } catch (error) {
        ElMessage.error('加载导出记录失败：' + (error.message || '未知错误'));
      } finally {
        this.scheduledLoading = false;
      }
    },
    async handleTriggerScheduledExport() {
      this.triggerLoading = true;
      try {
        await triggerScheduledExport();
        ElMessage.success('周报导出成功');
        this.fetchScheduledExports();
      } catch (error) {
        ElMessage.error('导出失败：' + (error.message || '未知错误'));
      } finally {
        this.triggerLoading = false;
      }
    },
    async handleDownloadScheduled(fileName) {
      try {
        const response = await downloadScheduledExport(fileName);
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        ElMessage.success('下载成功');
      } catch (error) {
        ElMessage.error('下载失败：' + (error.message || '未知错误'));
      }
    },
    async handleDeleteExport(row) {
      try {
        await ElMessageBox.confirm(
          `确定要删除导出记录 "${row.fileName}" 吗？文件也将同时删除。`,
          '确认删除',
          { confirmButtonText: '删除', cancelButtonText: '取消', type: 'warning' }
        );
      } catch {
        return;
      }
      try {
        await deleteScheduledExport(row.id);
        ElMessage.success('删除成功');
        this.fetchScheduledExports();
      } catch (error) {
        ElMessage.error('删除失败：' + (error.message || '未知错误'));
      }
    },
    statusTagType(status) {
      if (status === 'SUCCESS') return 'success';
      if (status === 'FAILED') return 'danger';
      return 'info';
    },
    statusLabel(status) {
      if (status === 'SUCCESS') return '成功';
      if (status === 'FAILED') return '失败';
      if (status === 'RUNNING') return '执行中';
      return status || '-';
    },
    formatFileSize(bytes) {
      if (bytes == null) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    showScheduledDialog(val) {
      if (val) {
        this.fetchScheduledExports();
      }
    },
  },
};
</script>

<style scoped>
.block {
  display: flex;
  justify-content: flex-end;
}
</style>
import { ElMessage, ElMessageBox } from 'element-plus';
